export default [
    {	path: "/thirdparty/edit/",
		component: () => import("../views/Thirdparty/Edit.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{	path: "/thirdparty/upload/",
		component: () => import("../views/Thirdparty/Upload.vue"),
		meta: {
			hasmainmenu: true
		}
	},
]
